import { render, staticRenderFns } from "./Param.vue?vue&type=template&id=60a5bf6a&"
import script from "./Param.vue?vue&type=script&lang=js&"
export * from "./Param.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports